<template>
  <div class="tag-dropdown-row">
    <DxCheckBox :value="isChecked"
                :disabled="tagDisabled"
                @value-changed="onToggleCheckbox"
    />
    <div class="color-box" :style="`background-color: ${ tagColor }`" />
    <span class="tag-name"
          :class="{ 'tag-modified': tagModified }"
          :title="tagName"> {{ tagName }}
    </span>
    <span class="tag-count"
          :class="{ 'tag-modified': tagModified }"
          v-if="tagShowCount">
      {{ tagCount }}
    </span>
  </div>
</template>

<script setup>
  import DxCheckBox from 'devextreme-vue/check-box'

  const props = defineProps([
    'tagId',
    'tagName',
    'tagColor',
    'tagCount',
    'isChecked',
    'tagShowCount',
    'tagDisabled',
    'tagModified'
  ])

  const emit = defineEmits(['checkboxToggle'])

  const onToggleCheckbox = (valueChangeEvent) => {
    emit('checkboxToggle', { isChecked: valueChangeEvent.value, tagName: props.tagName, tagId: props.tagId })
  }
</script>

<style scoped lang="scss">
  .tag-dropdown-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
    color: $almost-black;

    $tag-icon-size: 15px;

    .dx-checkbox-icon {
      width: $tag-icon-size;
      height: $tag-icon-size;
    }

    .dx-checkbox-indeterminate .dx-checkbox-icon::before {
      height: 6px;
      width: 6px;
      margin-top: -3px;
      margin-left: -3px;
      border-radius: 0;
    }

    .color-box {
      width: $tag-icon-size;
      height: $tag-icon-size;
      border-radius: 2px;
      flex-shrink: 0;
    }

    .tag-name {
      flex-grow: 1;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .tag-count {
      align-self: flex-end;
    }
  }

  .tag-modified {
    font-style: italic;
  }
</style>
